/**
 * Site label as displayed in v1 lists: "Name - Town" (town omitted when empty).
 * `siteName` is the name returned by every v2 site payload.
 */
export default function siteLabel(site: any): string {
	if (!site) return "";
	const name = site.siteName ?? site.name ?? "";
	const town = site.town?.trim();
	return name + (town?.length ? " - " + town : "");
}
